import { render, staticRenderFns } from "./Security.vue?vue&type=template&id=44b7408c&scoped=true"
import script from "./Security.vue?vue&type=script&lang=ts"
export * from "./Security.vue?vue&type=script&lang=ts"
import style0 from "./Security.vue?vue&type=style&index=0&id=44b7408c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b7408c",
  null
  
)

export default component.exports